import React, { useEffect, useState } from 'react';
import { NavigationTop } from './NavigationTop'; 
import { Navigation } from './Navigation'; 

const Header = () => {
    const [scrolled, setScrolled] = useState(false);

    const handleScroll = () => {
        const offset = window.scrollY;
        if (offset > 5) {  // この数値はheader-topの高さに応じて調整
            setScrolled(true);
        } else {
            setScrolled(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className="header">
            <NavigationTop />
            <Navigation className={scrolled ? "fixed" : ""} />
        </div>
    );
}

export default Header;

